/* @flow */

import React from 'react';
import {svgIconWrapper} from '../svg-icon-wrapper';
import NavIconSettings from './nav-icon-settings.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <NavIconSettings {...validProps} />;
}
SvgComponent.iconName = 'navIconSettings';

export const NavIconSettingsIcon = svgIconWrapper(SvgComponent);
